// assets/accessibility-fixes.js
(function () {
  function labelButtons() {
    // Open button(s)
    document.querySelectorAll('button.aasaved-cart-icon').forEach((btn) => {
      // Skip close buttons (they share the base class)
      if (btn.classList.contains('aasaved-cart-close-dropdown')) return;
      const hasName =
        btn.getAttribute('aria-label') ||
        btn.getAttribute('aria-labelledby') ||
        (btn.textContent && btn.textContent.trim().length > 0);
      if (!hasName) btn.setAttribute('aria-label', 'Open saved cart');
    });

    // Close button(s)
    document.querySelectorAll('button.aasaved-cart-close-dropdown').forEach((btn) => {
      const hasName =
        btn.getAttribute('aria-label') ||
        btn.getAttribute('aria-labelledby') ||
        (btn.textContent && btn.textContent.trim().length > 0);
      if (!hasName) btn.setAttribute('aria-label', 'Close saved cart');
    });
  }

  // Run now and again after app scripts mount DOM
  document.addEventListener('DOMContentLoaded', labelButtons);
  // In case content loads later
  const obs = new MutationObserver(labelButtons);
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();